import React from 'react';
import {
  FormHelperText, FormControl, TextField, InputAdornment,
} from '@mui/material';
import Calender from '@mui/icons-material/Event';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import moment from 'moment';
import { getCurrentLanguage } from 'utils';
import 'moment/locale/de';
import IconPopup from 'screens/shared/help-icon-popup';

export default ({
  label, value, onChange, onOpen = () => {}, onClose = () => {}, minDateTime = undefined,
  maxDateTime = undefined, disabled = false, clearable = false, helpText, error, info, clearSeconds,
}) => (
  <FormControl>
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={getCurrentLanguage()}>
      <MobileDateTimePicker
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              endAdornment: (
                <InputAdornment style={{ position: 'absolute', right: 12, pointerEvents: 'none' }} position="end"><Calender /></InputAdornment>
              ),
            }}
          />
        )}
        label={label}
        inputFormat="DD.MM.YYYY, HH:mm:ss"
        mask=""
        value={value || null}
        onChange={(date) => {
          if (date && clearSeconds) {
            date.set({ second: 0 });
          }
          onChange(date);
        }}
        onOpen={onOpen}
        onClose={onClose}
        disableCloseOnSelect
        minDateTime={minDateTime ? moment(minDateTime) : undefined}
        maxDateTime={maxDateTime ? moment(maxDateTime) : undefined}
        clearable={clearable}
        disabled={disabled}

        ampm={false}
        ampmInClock={false}

        OpenPickerButtonProps={{
          style: { marginRight: '0px' },
        }}
      />
    </LocalizationProvider>
    {
      (!!helpText && !error) && (
        <FormHelperText style={{ marginLeft: 0 }}>
          {helpText}
          { info && <IconPopup content={info} /> }
        </FormHelperText>
      )
    }
  </FormControl>
);
